export default __webpack_public_path__ + "static/media/numberswarmup_standard.29f499db.svg";